import React, { useContext, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { ConfigContext } from '../../Context/ConfigContext';
import axios from 'axios';
import { addToCart } from '../../Redux/features/Cart/CartSlice';
import { toast } from 'react-toastify';
import { calculateDiscountPercentage } from '../../Utils/Helper';
import { addToWishList, removeWishListItem } from '../../Redux/features/WishList/WishlistSlice';
import ProductDetailsInfo from './ProductDetailsInfo';

const ProductDetailsTop = () => {

    const { apiURL, apiHeaderJson, currency } = useContext(ConfigContext);
    const wishList = useSelector(state => state.Wishlist)


    const path = useLocation();
    const product_id = path.pathname.split('=')[1];

    const dispatch = useDispatch()
    const [data, setData] = useState([])
    const [productAllData, setProductAllData] = useState([])
    const [getProductSliderData, setGetProductSliderData] = useState([])
    const [productVariants, setProductVariants] = useState([])
    const [selectedVariant, setSelectedVariant] = useState(0);
    const [cartItemQuantity, setCartItemQuantity] = useState(1)
    const [loading, setLoading] = useState(false)

    const GetProductDetails = async (product_id) => {
        setLoading(true)
        const headers = apiHeaderJson;
        try {
            const response = await axios.get(`${apiURL}Products/GetProductDetails`, {
                params: { product_id: product_id },
                headers: apiHeaderJson,
                headers
            });
            setData(response.data.data[0]);
            setProductAllData(response?.data?.data);
            setProductVariants(response.data.product_variants);
            setSelectedVariant(response.data.product_variants[0]?.product_variant_id)
            setLoading(false)
        } catch (error) {
            console.log(error);
        }
    };

    const GetProductSlider = async () => {
        try {
            setGetProductSliderData([]);
            const response = await axios.get(`${apiURL}Home/GetProductSlider`, {
                params: {
                    product_id: product_id
                }

            })
            if (response.data.success) {
                setGetProductSliderData(response?.data?.data);
            }
        } catch (error) {
            console.log(error)
        }

    };

    const handleIncreaseQuantity = () => {
        setCartItemQuantity(cartItemQuantity + 1)
    }

    const handleDecreaseQuantity = () => {
        setCartItemQuantity(prevQuantity => (prevQuantity > 1 ? prevQuantity - 1 : 1));
    };
    const handleAddToCart = (product) => {
        const newProduct = { ...product, quantity: cartItemQuantity }
        dispatch(addToCart(newProduct))
        localStorage.setItem('cartQuantity', cartItemQuantity);
        toast.success(`${product.product_title} Added`, {
            position: "bottom-center",
        })
    }

    const CheckWishList = (product_id) => {
        return wishList.some((item) => item.product_id === product_id);
    }

    const handleVariantClick = (product_variant_id) => {
        const variantData = productAllData?.find(item => item?.product_variant_id === product_variant_id)
        if (variantData) {
            setSelectedVariant(variantData?.product_variant_id)
            setData(variantData)
        }
    }

    const settings = {
        customPaging: function (i) {
            return (
                <a>
                    <img src={`${'baseUrl'}/abstract0${i + 1}.jpg`} />
                </a>
            );
        },
        dots: true,
        dotsClass: "slick-dots slick-thumb",
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1
    };

    useEffect(() => {
        if (product_id) {
            GetProductDetails(product_id);
        }
    }, [product_id]);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [product_id]);

    useEffect(() => {
        GetProductSlider();
    }, [product_id]);

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [product_id]);


    const getStarPercent = (rating) => {
        return (rating / 5) * 100;
    };



    return (
        <>

            {loading ? (
                <div className="col-md-6 col-sm-12 col-xs-12 mb-md-0 mb-sm-5">
                    <div className="detail-gallery">
                        <div className="product-image-slider">
                            <div className="shimmer shimmer-slide" style={{ height: "400px", width: "100%", borderRadius: "10px" }}></div>
                        </div>
                        <div className="slider-nav-thumbnails mt-3 d-flex gap-2">
                            {Array.from({ length: 4 }).map((_, index) => (
                                <div key={index} style={{ flex: "0 0 auto", width: "80px", height: "80px" }}>
                                    <div className="shimmer shimmer-thumbnail" style={{ width: "100%", height: "100%", borderRadius: "6px" }}></div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            ) : (
                <div className="col-md-6 col-sm-12 col-xs-12 mb-md-0 mb-sm-5">
                    <div className="detail-gallery">
                        <div className="product-image-slider">
                            {getProductSliderData?.map((item) => (
                                <figure key={item.product_gallery_id} className="border-radius-10">
                                    {item.product_gallery_type === "image" && item.product_slider_image_url ? (
                                        <img
                                            src={item.product_slider_image_url}
                                            style={{ cursor: "pointer" }}
                                            alt="product image"
                                        />
                                    ) : item.product_gallery_type === "video" && item.product_video_url ? (
                                        <div className="video-wrapper">
                                            <iframe
                                                width="100%"
                                                height="500"
                                                src={item.product_video_url.replace("shorts/", "embed/")}
                                                title="product video"
                                                frameBorder="0"
                                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                                allowFullScreen
                                            ></iframe>
                                        </div>
                                    ) : null}
                                </figure>
                            ))}
                        </div>

                        <div className="slider-nav-thumbnails d-flex gap-2 mt-2">
                            {getProductSliderData?.map((item) => (
                                <div key={item.product_gallery_id}>
                                    {item.product_gallery_type === "image" && item.product_slider_image_url ? (
                                        <img
                                            src={item.product_slider_image_url}
                                            alt="thumbnail"
                                        />
                                    ) : item.product_gallery_type === "video" && item.product_video_url ? (
                                        <img
                                            src="https://img.icons8.com/ios-filled/100/play-button-circled.png"
                                            alt="video thumbnail"
                                        />
                                    ) : null}
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            )}

            <div className="col-md-6 col-sm-12 col-xs-12">
                <div className="detail-info pr-30 pl-30">
                    {loading ? (
                        <>
                            <div className="shimmer shimmer-text" style={{ height: "20px", width: "100px", marginBottom: "10px" }}></div>
                            <div className="shimmer shimmer-title" style={{ height: "30px", width: "60%", marginBottom: "20px" }}></div>

                            <div className="shimmer shimmer-rating" style={{ height: "16px", width: "100px", marginBottom: "15px" }}></div>

                            <div className="shimmer shimmer-price" style={{ height: "24px", width: "40%", marginBottom: "10px" }}></div>
                            <div className="shimmer shimmer-desc" style={{ height: "60px", width: "100%", marginBottom: "20px" }}></div>

                            <div className="shimmer shimmer-variants" style={{ height: "40px", width: "80%", marginBottom: "20px" }}></div>

                            <div className="shimmer shimmer-qty" style={{ height: "40px", width: "150px", marginBottom: "20px" }}></div>

                            <div className="d-flex gap-2">
                                <div className="shimmer shimmer-button" style={{ height: "40px", width: "120px" }}></div>
                                <div className="shimmer shimmer-icon" style={{ height: "40px", width: "40px", borderRadius: "50%" }}></div>
                            </div>
                        </>
                    ) : (
                        <>
                            <span className="stock-status out-stock"> Sale Off </span>
                            <h2 className="title-detail" style={{ cursor: "pointer" }}>
                                {data?.product_title}
                            </h2>

                            {data?.product_stock_status !== 0 && (
                                <>
                                    <div className="product-detail-rating">
                                        <div className="product-rate-cover text-end">
                                            <div className="product-rate d-inline-block">
                                                <div className="product-rating" style={{ width: getStarPercent(data?.average_rating) + '%' }} />
                                            </div>
                                            <span className="font-small ml-5 text-muted">{data.average_rating}</span>
                                        </div>
                                    </div>
                                    <div className="clearfix product-price-cover">
                                        <div className="product-price primary-color float-left">
                                            <span className="current-price text-brand" style={{ cursor: "pointer" }}>
                                                {currency}{data?.product_variant_sale_price}
                                            </span>
                                            <span>
                                                <span className="save-price font-md color3 ml-15" style={{ cursor: "pointer" }}>
                                                    {calculateDiscountPercentage(data?.product_variant_mrp_price, data?.product_variant_sale_price)}% Off
                                                </span>
                                                <span className="old-price font-md ml-15" style={{ cursor: "pointer" }}>
                                                    {currency}{data?.product_variant_mrp_price}
                                                </span>
                                            </span>
                                        </div>
                                    </div>
                                </>
                            )}

                            <div className="short-desc mb-30">
                                <p className="font-lg" style={{ cursor: "pointer" }}>
                                    {data?.product_short_description}.
                                </p>
                            </div>

                            <div className="attr-detail attr-size mb-30">
                                <strong className="mr-10" style={{ cursor: "pointer" }}>Size / Weight:</strong>
                                <ul className="list-filter size-filter font-small">
                                    {productVariants.map((variant) => (
                                        <li
                                            key={variant.product_variant_id}
                                            style={{ cursor: "pointer" }}
                                            className={`mx-1 ${selectedVariant === variant.product_variant_id ? "active" : ""}`}
                                            onClick={() => handleVariantClick(variant.product_variant_id)}
                                        >
                                            <a>{variant.product_variant_title}</a>
                                        </li>
                                    ))}
                                </ul>
                            </div>

                            <div className="detail-extralink mb-50">
                                <div className="detail-qty border radius">
                                    <span onClick={handleDecreaseQuantity} className="qty-down" style={{ cursor: "pointer", color: "#A65050" }}>
                                        <i className="fi-rs-angle-small-down" />
                                    </span>
                                    <input
                                        type="text"
                                        name="quantity"
                                        className="qty-val"
                                        defaultValue={1}
                                        value={cartItemQuantity}
                                        min={1}
                                        style={{ cursor: "pointer" }}
                                    />
                                    <span onClick={handleIncreaseQuantity} className="qty-up" style={{ cursor: "pointer", color: "#A65050" }}>
                                        <i className="fi-rs-angle-small-up" />
                                    </span>
                                </div>

                                <div className="product-extra-link2">
                                    {data.product_stock_status === 0 ? (
                                        <span className="stock-status btn mt-2 out-stock mb-0"> Out Stock </span>
                                    ) : (
                                        <button
                                            type="submit"
                                            onClick={() => handleAddToCart(data)}
                                            className="button button-add-to-cart"
                                        >
                                            <i className="fi-rs-shopping-cart" /> Add to cart
                                        </button>
                                    )}

                                    {CheckWishList(data?.product_id) === true ? (
                                        <a
                                            onClick={() => dispatch(removeWishListItem(data.product_id))}
                                            aria-label={`Remove From Wishlist`}
                                            className="action-btn small hover-up"
                                            style={{ background: '#FDC040' }}
                                        >
                                            <i className="fi-rs-heart" />
                                        </a>
                                    ) : (
                                        <a
                                            onClick={() => dispatch(addToWishList(data))}
                                            aria-label="Add To Wishlist"
                                            className="action-btn small hover-up"
                                        >
                                            <i className="fi-rs-heart" />
                                        </a>
                                    )}
                                </div>
                            </div>
                        </>
                    )}
                </div>
            </div>

            <div className='tab-style3 '>
                <div className='nav nav-tabs mt-20 '>

                    <ProductDetailsInfo
                        shortDescription={data?.product_variant_short_description}
                    />
                </div>
            </div>
        </>
    )
}

export default ProductDetailsTop